let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("48JGY"), load("63MsJ"), load("k9ktU")]).then(() => parcelRequire('iFaMg'));